# Sample messages for the chat demo
return if Message.count > 0

Message.create!(username: "Alice", body: "Hey everyone! Welcome to the chat room.")
Message.create!(username: "Bob", body: "Hi Alice! This is pretty cool.")
Message.create!(username: "Carol", body: "Love how messages appear in real-time!")
Message.create!(username: "Alice", body: "Yeah, Turbo Streams makes it so easy.")

puts "Created #{Message.count} sample messages"
